<template><div><h1>VUX V2.8.0 发布日志</h1>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[fix] 修复输入框难以移动光标</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[change] 去除空的根节点 #2371</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[fix] 修复初始值为0时不显示清除按钮问题 #2482</li>
</ul>
<h2><a href="/zh-CN/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] 修复初始化时 on-change 错误触发</li>
</ul>
<h2><a href="/zh-CN/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[feature] 添加属性 disabled #2522</li>
</ul>
<h2><a href="/zh-CN/components/cookie.html">Cookie</a></h2>
<ul><li>[feature] change to es6 module style</li>
</ul>
<h2><a href="/zh-CN/components/date.html">Date</a></h2>
<ul><li>[feature] change to es6 module style</li>
</ul>
<h2><a href="/zh-CN/components/number.html">Number</a></h2>
<ul><li>[feature] change to es6 module style</li>
</ul>
<h2><a href="/zh-CN/components/wechat.html">Wechat</a></h2>
<ul><li>[feature] 更新到 1.3.2 版本 #2396</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.8.0 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.8.0-268.vue?5c6802db